<div class="pl-shell" #painelWrapper [class.tela-cheia]="telaCheiaAtiva">
  <div class="container" [class.container-tela-cheia]="telaCheiaAtiva">

    <!-- ── PAGE HEADER ── -->
    <div class="page-header">
      <div class="page-header-icon">
        <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 24 24" fill="none"
          stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <rect x="1" y="3" width="15" height="13" rx="1"/>
          <path d="M16 8h4l3 4v4h-7V8z"/>
          <circle cx="5.5" cy="18.5" r="2.5"/>
          <circle cx="18.5" cy="18.5" r="2.5"/>
        </svg>
      </div>
      <div style="flex:1">
        <h1>Painel de Logística</h1>
        <p>Pedidos aguardando expedição</p>
      </div>

      <!-- Badge da empresa filtrada — visível mesmo em tela cheia. -->
      <div class="badge-empresa-painel"
           [style.background]="empresaState.corClaraPorCodEmp(empresaState.selecionada, 0.78)"
           [style.border-color]="empresaState.corPorCodEmp(empresaState.selecionada)">
        <span class="badge-empresa-dot" [style.background]="empresaState.corPorCodEmp(empresaState.selecionada)"></span>
        <span class="badge-empresa-texto">
          Empresa {{ empresaState.selecionada }}<ng-container *ngIf="nomeEmpresaAtual"> — {{ nomeEmpresaAtual }}</ng-container>
        </span>
      </div>

      <!-- Sumário rápido -->
      <div class="header-stats" *ngIf="!carregando && pedidos.length > 0">
        <div class="stat-chip">
          <span class="stat-num">{{ pedidos.length }}</span>
          <span class="stat-label">Pedidos</span>
        </div>
      </div>

      <div class="header-actions">
        <div class="timer-config">
          <label for="timerInputLog">Atualizar a cada (s):</label>
          <input id="timerInputLog" type="number" class="input-timer" [(ngModel)]="intervaloAtualizacao"
            (change)="onIntervaloChange()" min="0" max="300" />
        </div>

        <button type="button" class="btn-novo" (click)="buscar()" [disabled]="carregando">
          <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 24 24" fill="none"
            stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <polyline points="23 4 23 10 17 10"/>
            <path d="M20.49 15a9 9 0 1 1-2.12-9.36L23 10"/>
          </svg>
          <span *ngIf="!telaCheiaAtiva">Atualizar {{ tempoRestante > 0 ? '(' + tempoRestante + 's)' : '' }}</span>
        </button>

        <button type="button" class="btn-novo btn-secundario" (click)="alternarTelaCheia()">
          <svg *ngIf="!telaCheiaAtiva" xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 24 24"
            fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <path d="M8 3H5a2 2 0 0 0-2 2v3m18 0V5a2 2 0 0 0-2-2h-3m0 18h3a2 2 0 0 0 2-2v-3M3 16v3a2 2 0 0 0 2 2h3"/>
          </svg>
          <svg *ngIf="telaCheiaAtiva" xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 24 24"
            fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <path d="M8 3v3a2 2 0 0 1-2 2H3m18 0h-3a2 2 0 0 1-2-2V3m0 18v-3a2 2 0 0 1 2-2h3M3 16h3a2 2 0 0 1 2 2v3"/>
          </svg>
          <span *ngIf="!telaCheiaAtiva">Maximizar</span>
          <span *ngIf="telaCheiaAtiva">Sair</span>
        </button>
      </div>
    </div>

    <!-- ── ERRO ── -->
    <div *ngIf="erro" class="alerta alerta-erro">{{ erro }}</div>

    <!-- ── TABELA ── -->
    <div class="tabela-card">

      <div *ngIf="carregando" class="loading-row">
        <app-loading-indicator></app-loading-indicator>
        <span>Carregando pedidos...</span>
      </div>

      <div *ngIf="!carregando && pedidos.length === 0 && !erro" class="vazio-row">
        Nenhum pedido em logística no momento.
      </div>

      <ng-container *ngIf="!carregando && pedidos.length > 0">
        <table class="tabela">
          <thead>
            <tr>
              <th>Nº Pedido</th>
              <th class="col-center">Data</th>
              <th>Cliente</th>
              <th>Vendedor</th>
              <th class="col-center">Prefixo</th>
              <th class="col-center">Itens</th>
              <th>Conferente</th>
              <th class="col-center">Fim Conferência</th>
              <th class="col-center">Prioridade</th>
              <th class="col-center">Imediato</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let p of pedidosPagina" class="linha-clicavel">
              <td class="col-nunota">#{{ p.nunota }}</td>
              <td class="col-center col-data">{{ p.dtneg || '—' }}</td>
              <td class="col-cliente" [title]="p.nomeCliente">{{ p.nomeCliente }}</td>
              <td class="col-vend">{{ p.vendedor || '—' }}</td>
              <td class="col-center">
                <span *ngIf="p.prefixo" class="badge-prefixo">✈ {{ p.prefixo }}</span>
                <span *ngIf="!p.prefixo" class="col-vazio">—</span>
              </td>
              <td class="col-center">
                <span class="itens-badge">{{ p.totalItens }}</span>
              </td>
              <td class="col-sep">
                <span *ngIf="p.confNome">{{ p.confNome }}</span>
                <span *ngIf="!p.confNome" class="col-vazio">—</span>
              </td>
              <td class="col-center col-data">{{ p.dataFimConf || '—' }}</td>
              <td class="col-center">
                <span class="badge-prioridade" [class.badge-alta]="p.prioridade === 'S'">
                  {{ p.prioridade === 'S' ? 'Alta' : 'Normal' }}
                </span>
              </td>
              <td class="col-center">
                <span class="badge-imediato" *ngIf="p.imediato === 'S'">Imediato</span>
                <span class="badge-normal" *ngIf="p.imediato !== 'S'">-</span>
              </td>
            </tr>
          </tbody>
        </table>

        <!-- ── RODAPÉ ── -->
        <div class="tabela-rodape">
          <span class="rodape-total">
            {{ pedidos.length }} pedido{{ pedidos.length !== 1 ? 's' : '' }}
          </span>

          <div class="rodape-paginacao">
            <div class="por-pagina">
              <span>Exibir</span>
              <select [(ngModel)]="itensPorPagina" (ngModelChange)="onItensPorPaginaChange()" class="sel-pagina">
                <option *ngFor="let n of opcoesPorPagina" [value]="n">{{ n }}</option>
              </select>
              <span>por página</span>
            </div>

            <div class="pag-controles">
              <button class="pag-btn" (click)="irParaPagina(1)" [disabled]="paginaAtual === 1" title="Primeira">«</button>
              <button class="pag-btn" (click)="irParaPagina(paginaAtual - 1)" [disabled]="paginaAtual === 1" title="Anterior">‹</button>
              <button *ngIf="paginas[0] > 1" class="pag-btn pag-ellipsis" disabled>…</button>
              <button *ngFor="let p of paginas" class="pag-btn" [class.pag-ativo]="p === paginaAtual" (click)="irParaPagina(p)">{{ p }}</button>
              <button *ngIf="paginas[paginas.length - 1] < totalPaginas" class="pag-btn pag-ellipsis" disabled>…</button>
              <button class="pag-btn" (click)="irParaPagina(paginaAtual + 1)" [disabled]="paginaAtual === totalPaginas" title="Próxima">›</button>
              <button class="pag-btn" (click)="irParaPagina(totalPaginas)" [disabled]="paginaAtual === totalPaginas" title="Última">»</button>
            </div>
          </div>
        </div>
      </ng-container>
    </div>

  </div>
</div>
